module.exports = __webpack_public_path__ + "media/images/partners/oxfam-c484a935fef9737efbf90b947e43332d.png";